export const QA_NAME_INHABITANTS_TABLE = 'Inhabitant'

export const QA_NAME_INHABITANTS_TABLE_STATISTIC_BTN = 'Statistic'

export const QA_NAME_INHABITANTS_TABLE_ADD_NEW = 'addNewInhabitant'

export const CREATE_INHABITANT_ACTION_NAME = 'createInhabitant'

export const INHABITANTS_EMAIL_DRAFT_PREFIX = 'inhabitants-email'
